import { create, all } from 'mathjs';

// Singleton — create(all) costs ~200 ms on first call.
// Module-level ensures it is initialised once per application load,
// shared by every hook and utility that needs formula evaluation.
const _submissionMath = create(all, {});

_submissionMath.import({
  ISNULL: (value, replacement) =>
    value === null || value === undefined ? replacement : value,
});

export { _submissionMath };
